export const locale = {
    lang: 'en',
    data: {
        'HEADERS': {
            'OfferTravelingAmount': 'Offer Traveling Amount Per Minute'
        },
        'FIELDS': {
            'TravelingAmount': 'Traveling amount per. min',
            KilometerPerHours: 'Kilometer per hours',
        },
        'BUTTONS': {
            'Save': 'Save',
            'Back': 'Back',
        },
        'MESSAGES': {
            'Failed': 'Operation failed , try later',
            'Success': 'Success'
        }
    }
}